export const TRUCK_TRANSPARENT_FALSE = ['Truck2_DoorOpen', 'Truck1', 'Truck8']
// export const TRUCK_DOOR = ['Truck2_Door']
export const TRUCK_DOOR = ['nothingneverhere']
export const TRUCK_HIDE = ['Vacuum']
export const TRUCK_BLACK = ['Vacuum']
export const REMOTE_MODEL = './models/remote.glb'
export const BOOM_FREESTYLE_URL = './models/f4/freestyleboom.glb'

export const ENVMAP = [
  'px.jpg', 'nx.jpg', 'py.jpg', 'ny.jpg', 'pz.jpg', 'nz.jpg'
].map(item => './environment/envmap/' + item)

export const ENV_MODEL = './environment/environment.glb'
export const BOX_MESHES = ['Control_Box_VanBody', 'EngineControl_button', 'EngineIncrease_button', 'Knob_Rotate', 'WaterPumpManual_button', 'WaterPumpReset_button', 'WaterPumpBypass_button']
export const BOX_LIGHTS = ['SwitchEm3', 'SwitchEm2', 'SwitchEm1', 'SwitchEm4', 'SwitchEm5', 'SwitchEm6', 'SwitchEm007']
export const BOX_PLANE_COLOR = '#ec5601'
export const SWITCH_MESHES = ['EngineIncrease_button']
export const BOX_POSITION = [-74.526448258637, 150, 610.1007287091015]
export const BOX_POSITION_MOB = [-61.27620987423338, 150, 615.5230000610868]
export const AFTER_BOX_OUT_POS = {
  camera: [-338.23824460005983, 167.88226010095732, 81.43989587223737],
  controls: [748.4811754003969, 150, 162.1251007803845],
}

export interface GLTF {
  animations: THREE.AnimationClip[];
  scene: THREE.Scene;
  scenes: THREE.Scene[];
  cameras: THREE.Camera[];
  asset: object;
}
// export const BOX_POSITION_mBO = {
//   camera:  [-99.34007173767151, 195.60711749797173, 87.35703599736644],
//   controls: [-61.27620987423338, 150, 615.5230000610868]
// }